import { render } from "./InvoicesView.vue?vue&type=template&id=61bd94ca&scoped=true"
import script from "./InvoicesView.vue?vue&type=script&lang=js"
export * from "./InvoicesView.vue?vue&type=script&lang=js"

import "./InvoicesView.vue?vue&type=style&index=0&id=61bd94ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61bd94ca"]])

export default __exports__